import React, { createContext, useState, useContext } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
   const [isSidebarOpen, setSidebarOpen] = useState(true);

   const toggleSidebar = () => {
      setSidebarOpen((prevState) => !prevState);
   };

   return (
      <SidebarContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
         {children}
      </SidebarContext.Provider>
   );
};

export const useSidebar = () => {
   return useContext(SidebarContext);
};
